import {
    CodStatus,
    NatureOfComplaint,
    ReferenceNumberType,
    ReferenceNumberTypeDomestic,
    ReferenceNumberTypeInternational,
    Region
} from '../../../enums';
import { IOrderLine } from '../order-line.interface';

export interface ICod {
    id?: string;
    serial?: number;
    region: Region;
    createdAt: Date;
    createdBy: string;
    closedAt?: Date;
    assignedAt?: Date;
    assignedTo?: string;
    natureOfComplaint: NatureOfComplaint;
    status: CodStatus;
    affectedOrderLines?: IOrderLine[];
    referenceNumber: string;
    referenceNumberType: ReferenceNumberTypeDomestic | ReferenceNumberTypeInternational | ReferenceNumberType;
    lastModified?: Date;
    lastModifiedBy?: string;
    executionIds?: string[];
    currentStatusExecutionId?: string;
    productDiscrepancy?: boolean;
    financialAdjustmentValue?: number;
    shipToCountryCode: string;
    soldToCustomerName?: string;
}
